export { convertLabelStylePropToObject } from './label';
export { convertIconColorPropToObject } from './icon';
